<app-background-card title="{{ 'common.selecthor.admin.dashboard' | transloco }}">
  <app-dashboard-overview />
</app-background-card>

<app-background-card title="{{ 'project.overviewHeader' | transloco }}" styleClass="mt-4">
  <app-project-overview />
</app-background-card>
